import React from 'react'
import {
  AppBar,
  ButtonBase,
  Container,
  Divider,
  Link as LinkHtml,
  Grid,
  IconButton,
  Toolbar,
  Typography,
  makeStyles
} from '@material-ui/core'
import { Facebook, Instagram } from '@material-ui/icons'
import { useTheme } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import track from '~/track'
import { useLiterals } from '~/components/Literals'

import LogoOndeTem from '~/assets/logo-ondetem.webp'
import LogoOndeTemBranco from '~/assets/logo-ondetem-branco.webp'
import SemGluten from '~/assets/homeImages/semGluten.webp'
import Vegano from '~/assets/homeImages/Vegano.webp'
import SemLactose from '~/assets/homeImages/SemLactose.webp'
import Diet from '~/assets/homeImages/Diet.webp'
import Cerveja from '~/assets/homeImages/Cerveja.webp'
import Cafe from '~/assets/homeImages/Cafe.webp'
import Sucos from '~/assets/homeImages/Sucos.webp'
import Chocolate from '~/assets/homeImages/Chocolate.webp'
import SearchField from '~/containers/SearchField'

import Ajinomoto from '~/assets/homeBrands/Ajinomoto.webp'
import Danone from '~/assets/homeBrands/Danone.webp'
import felps from '~/assets/homeBrands/felps.webp'
import Frooty from '~/assets/homeBrands/Frooty.webp'
import hileia from '~/assets/homeBrands/hileia.webp'
import hyde from '~/assets/homeBrands/hyde.webp'
import Jasmine from '~/assets/homeBrands/Jasmine.webp'
import Momy from '~/assets/homeBrands/Momy.webp'
import natures from '~/assets/homeBrands/natures.webp'
import naturesone from '~/assets/homeBrands/naturesone.webp'
import Ninho from '~/assets/homeBrands/Ninho.webp'
import Paviloche from '~/assets/homeBrands/Paviloche.webp'
import Seara from '~/assets/homeBrands/Seara.webp'
import Unicharm from '~/assets/homeBrands/Unicharm.webp'
import VidaVeg from '~/assets/homeBrands/VidaVeg.webp'
import Vigor from '~/assets/homeBrands/Vigor.webp'
import Xando from '~/assets/homeBrands/Xando.webp'

const useStyles = makeStyles((theme) => ({
  '@global': {
    html: {
      height: '100%'
    },
    body: {
      overflow: 'auto',
      height: '100%'
    },
    a: {
      textDecoration: 'underline'
    }
  },

  root: {
    position: 'relative',
    overflow: 'hidden',
    textAlign: 'center'
  },

  appBar: {
    boxShadow: 'none',
    marginBottom: 40,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0
    }
  },

  introduction: {
    position: 'relative',
    paddingBottom: '25vh',
    zIndex: 50,
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      minHeight: '500px'
    }
  },
  introTitle: {
    marginBottom: 48,
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      marginBottom: 16
    }
  },

  logoIntro: {
    marginBottom: 32,
    maxWidth: 180,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 16
    }
  },

  searchField: {
    padding: 16,
    width: '100%',
    maxWidth: 600,
    borderRadius: 32,
    boxShadow: '0 0 5px rgba(33,33,33, .3)'
  },

  buttonDown: {
    zIndex: '99',
    position: 'absolute',
    bottom: 85,
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: '#fff',
    color: theme.palette.primary.main,
    borderColor: 'transparent transparent #000 transparent',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, .9)'
    }
  },

  categories: {
    position: 'relative',
    marginTop: -60,
    paddingBottom: 160,
    backgroundColor: theme.palette.primary.main,
    borderColor: 'transparent transparent #000 transparent',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 80
    }
  },
  categoriesTitle: {
    position: 'relative',
    zIndex: 5,
    color: '#fff',
    marginBottom: 48,
    fontWeight: 'bold'
  },
  corner: {
    display: 'block',
    position: 'absolute',
    bottom: 'calc(100% - 60px)',
    left: '50%',
    transform: 'translateX(-50%)',
    minWidth: '100vw',
    '& path': {
      width: '100%'
    }
  },
  partners: {
    backgroundColor: '#fff',
    padding: '80px 0'
  },

  catImage: {
    position: 'relative',
    height: 200,
    width: '100%',
    borderRadius: 16,
    overflow: 'hidden',
    '&:hover, &$focusVisible': {
      zIndex: 1,
      '& $imageBackdrop': {
        opacity: 0.15
      }
    }
  },
  focusVisible: {},

  imageButton: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.common.white
  },

  imageSrc: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center 40%'
  },

  imageBackdrop: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.common.black,
    opacity: 0.4,
    transition: theme.transitions.create('opacity')
  },

  footer: {
    paddingTop: 80,
    paddingBottom: 32,
    backgroundColor: theme.palette.grey[900],
    color: theme.palette.getContrastText(theme.palette.grey[900])
  },

  footerLinks: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },

  footerLogo: {
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    }
  },

  footerIcons: {
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    }
  },

  copyright: {
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center'
    }
  },

  linkFooter: {
    fontSize: '16px',
    color: '#fff'
  }
}))

const getCategories = (getLiteral) => [
  { label: getLiteral('2057'), value: 'semgluten', image: SemGluten },
  { label: getLiteral('2058'), value: 'vegano', image: Vegano },
  { label: getLiteral('2059'), value: 'semlactose', image: SemLactose },
  { label: getLiteral('2060'), value: 'diet', image: Diet },
  { label: getLiteral('2061'), value: 'cerveja', image: Cerveja },
  { label: getLiteral('2062'), value: 'café', image: Cafe },
  { label: getLiteral('2063'), value: 'suco', image: Sucos },
  { label: getLiteral('2064'), value: 'chocolate', image: Chocolate }
]

const partners = [
  { title: 'ajinomoto', image: Ajinomoto, ondetem: true },
  { title: 'danonenutricia', image: Danone },
  { title: 'felps', image: felps },
  { title: 'frooty', image: Frooty },
  { title: 'hileia', image: hileia },
  { title: 'mupy', image: hyde },
  { title: 'jasmine', image: Jasmine },
  { title: 'mamypoko', image: Momy },
  { title: 'naturesheart', image: natures },
  { title: 'naturalone', image: naturesone },
  { title: 'ninho', image: Ninho },
  { title: 'paviloche', image: Paviloche },
  { title: 'seara', image: Seara },
  { title: 'mamypoko', image: Unicharm },
  { title: 'vidaveg', image: VidaVeg },
  { title: 'vigor', image: Vigor, ondetem: true },
  { title: 'xando', image: Xando }
]

function SocialIcons({ color }) {
  return (
    <div>
      <IconButton
        target="_blank"
        component={LinkHtml}
        href="https://www.facebook.com/ondetem.online"
        style={{ color }}
      >
        <Facebook />
      </IconButton>
      <IconButton
        target="_blank"
        component={LinkHtml}
        href="https://www.instagram.com/ondetem.app/"
        style={{ color }}
      >
        <Instagram />
      </IconButton>
    </div>
  )
}

export default function HomePage({ position }) {
  const classes = useStyles()
  const theme = useTheme()
  const { getLiteral } = useLiterals()

  return (
    <div className={classes.root}>
      <div className={classes.introduction}>
        <Container maxWidth="lg">
          <AppBar color="transparent" position="static" className={classes.appBar}>
            <Toolbar style={{ justifyContent: 'flex-end' }}>
              <SocialIcons color="#ccc" />
            </Toolbar>
          </AppBar>

          <img src={LogoOndeTem} className={classes.logoIntro} />

          <Typography variant="h4" component="h1" className={classes.introTitle}>
            {getLiteral('2052')}
          </Typography>

          <SearchField className={classes.searchField} isHome q="" position={position} />
        </Container>
      </div>

      <div className={classes.categories} id="categories">
        <svg
          width="2540"
          height="208"
          viewBox="0 0 2540 208"
          fill={theme.palette.primary.main}
          className={classes.corner}
        >
          <path d="M0 0C0 0 772.547 98.4428 1270 98.4428C1767.45 98.4428 2540 0 2540 0V208H0V0Z" />
        </svg>

        <Container maxWidth="lg">
          <Typography variant="h4" component="h2" className={classes.categoriesTitle}>
            {getLiteral('1007')}
          </Typography>
          <Grid container spacing={2}>
            {getCategories(getLiteral).map((category, index) => (
              <Grid item xs={6} md={3} key={index}>
                <ButtonBase
                  focusRipple
                  className={classes.catImage}
                  focusVisibleClassName={classes.focusVisible}
                  component={Link}
                  to={`/busca?q=tag:${category.value}`}
                >
                  <span
                    className={classes.imageSrc}
                    style={{
                      backgroundImage: `url(${category.image})`
                    }}
                  />
                  <span className={classes.imageBackdrop} />
                  <span className={classes.imageButton}>
                    <Typography
                      component="h3"
                      variant="h4"
                      color="inherit"
                      className={classes.imageTitle}
                    >
                      {category.label}
                    </Typography>
                  </span>
                </ButtonBase>
              </Grid>
            ))}
          </Grid>
        </Container>
      </div>
      <div className={classes.partners}>
        <Container maxWidth="lg">
          <Typography color="primary" variant="h4" style={{ marginBottom: 48, fontWeight: 'bold' }}>
            {getLiteral('2065')}
          </Typography>
          <Grid container spacing={1} justify="center">
            {partners.map((partner, index) => (
              <Grid item xs={4} sm={3} md={2} key={index}>
                <Link
                  to={
                    partner.ondetem
                      ? `/busca?q=${partner.title}`
                      : `/busca?q=marca:${partner.title}`
                  }
                  onClick={() => track('cliqueMarca', { category: 'home', name: partner.title })}
                >
                  <img src={partner.image} style={{ maxWidth: '100%' }} />
                </Link>
              </Grid>
            ))}
          </Grid>
        </Container>
      </div>

      <div className={classes.footer}>
        <Container maxWidth="lg">
          <Grid container spacing={3} alignItems="center">
            <Grid container item xs={12} sm={3} className={classes.footerLogo}>
              <img src={LogoOndeTemBranco} style={{ maxWidth: '100%', width: 180, height: 112 }} />
            </Grid>

            <Grid
              container
              item
              xs={12}
              md={6}
              justify="space-between"
              className={classes.footerLinks}
            >
              <LinkHtml
                className={classes.linkFooter}
                href="https://www.gofind.online/googlemeunegocio/"
              >
                {getLiteral('2066')}
              </LinkHtml>
              <br />
              <LinkHtml className={classes.linkFooter} href="https://www.gofind.online/industria/">
                {getLiteral('2067')}
              </LinkHtml>
            </Grid>

            <Grid container item xs={12} sm={3} className={classes.footerIcons}>
              <SocialIcons color="white" classes={classes} />
            </Grid>
          </Grid>
        </Container>

        <Divider style={{ backgroundColor: 'rgba(255,255,255, .4)', margin: '32px 0' }} />

        <Container maxWidth="lg">
          <Typography variant="caption" className={classes.copyright}>
            © 2020 ${getLiteral('2068')}
          </Typography>
        </Container>
      </div>
    </div>
  )
}
